<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-background-process`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 6a2 2 0 012 2v24a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h36zm-3 33a1 1 0 011 1v2a1 1 0 01-1 1H9a1 1 0 01-1-1v-2a1 1 0 011-1h30zM8 10h32v20H8V10zm9 9a1 1 0 011 1v2a1 1 0 01-1 1h-4a1 1 0 01-1-1v-2a1 1 0 011-1h4zm19 1a1 1 0 00-1-1H23a1 1 0 00-1 1v2a1 1 0 001 1h12a1 1 0 001-1v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconBackgroundProcess',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
